// @flow
import { delay } from 'redux-saga';
import {
  call,
  put,
  race,
  select,
  takeEvery,
  takeLatest,
  all,
} from 'redux-saga/effects';

import {
  TEMPORARY_EVENT_STARTED,
} from '../types/temporaryEvents';
import * as selectors from '../reducers';
import * as actions from '../actions/temporalBanners';
import * as temporaryEventsActions from '../actions/temporaryEvents';

function* startTemporaryEvent(action) {
  const { id } = action.payload;
  const { lifespan } = yield select(selectors.getTemporaryEvent, id);

  yield call(delay, lifespan);

  yield put(temporaryEventsActions.complete(id));
}

export function* watchStartTemporaryEvent(): Iterator<any> {
  yield takeEvery(
    TEMPORARY_EVENT_STARTED,
    startTemporaryEvent,
  );
}


// WEBPACK FOOTER //
// ./src/scripts/sagas/temporaryEvents.js